import { mapObjIndexed } from 'ramda'

export const invertColors = (colors, theme) => {
  if (theme === 'light') return colors
  return mapObjIndexed((value, key, colors) => {
    key = getInvertedKey(key)
    return colors[key] || value
  }, colors)
}

const getInvertedKey = key => {
  if (key === 'white') return 'dark1'
  if (key === 'black') return 'white'
  if (key.startsWith('light')) return key.replace('light', 'dark')
  if (key.startsWith('dark')) return key.replace('dark', 'light')
  return key
}

export const formatColorProps = (props, theme) => {
  if (!theme || props.__formattedForTheme === true) return props

  let formattedProps = { __formattedForTheme: true, ...props }

  Object.entries(props).forEach(([key, value]) => {
    if (!key.includes('_')) return value
    const [initialKey, keyTheme] = key.split('_')

    if (theme === keyTheme) {
      formattedProps[initialKey] = getInvertedKey(value)
    }
  })

  return formattedProps
}
